import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import './quasar'
import firestore from './store/firestore'
import firebase from 'firebase/app'
import 'firebase/auth'
import axios from 'axios'
import componentHelper from './js/customMdParse/componentHelper'
import lodash from 'lodash'
import { resetCustomMd, updateCustomMd } from './js/customMdParse/customMdParse'
import { ComponentDefinition } from './js/customMdParse/ComponentDefinition'
import { updateComponentHtmlInDOM } from './js/customMdParse/components'
import moment from 'moment'
// import DiffMatchPatch from 'diff-match-patch'

Vue.config.productionTip = false

const app = {
  router,
  store,
  render: h => h(App)
}

let vinst = new Vue(app).$mount('#app')

Vue.prototype.$_ = lodash
Vue.prototype.$firestore = firestore
Vue.prototype.$axios = axios

firebase.auth().onAuthStateChanged(user => {
  if (!vinst) vinst = new Vue(app)
  app.store.commit('setCurrentUser', firebase.auth().currentUser)
})
window.Vue = Vue

Vue.component('ace-editor', () => import('./components/AceVue'))
window.$ch = componentHelper
lodash.contains = lodash.includes // Fix for JSHINT
window._ = lodash
// window.diff_match_patch = DiffMatchPatch
window.DIFF_DELETE = -1
window.DIFF_INSERT = 1
window.DIFF_EQUAL = 0
window.app = app
window._vue = vinst
window.moment = moment

window.render_md = function (markdown, components, note = null) {
  resetCustomMd()
  return updateCustomMd(markdown || '', components, note)
} // eslint-disable-line vue/no-side-effects-in-computed-properties
window.ComponentDefinition = ComponentDefinition
window.updateComponentHtmlInDOM = updateComponentHtmlInDOM
window.resetCustomMd = resetCustomMd
// Vue.config.warnHandler = function (msg, vm, trace) {
//   // `trace` is the component hierarchy trace
//   window.$ch.log(msg)
//   window.$ch.log(trace)
// }
